(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lomvor-color-hub"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.lv-color-hub__video').forEach((video) => {
  video.controls = false;
  video.muted = true;
  video.setAttribute('disablepictureinpicture', '');
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting && !motion.matches) {
        video.play().catch(() => {});
      } else if (!entry.isIntersecting) {
        video.pause();
      }
    });
  }, { threshold: 0.2 });
  observer.observe(video);
  motion.addEventListener('change', () => { if (motion.matches) video.pause(); });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lomvor-home-v2"]) return;
  try {
    
(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const hardMute = (video) => {
    if (!video) return;
    video.muted = true;
    video.defaultMuted = true;
    video.volume = 0;
    video.setAttribute('muted','');
    video.setAttribute('playsinline','');
  };
  document.querySelectorAll('.section-lomvor-home-v2 video').forEach(hardMute);

  const initColorStories = (root = document) => {
    root.querySelectorAll('[data-lv-color-story]').forEach((story) => {
      if (story.dataset.lvColorReady === 'true') return;
      story.dataset.lvColorReady = 'true';

      const track = story.querySelector('[data-lv-color-track]');
      const scenes = Array.from(story.querySelectorAll('[data-lv-color-scene]'));
      const copies = Array.from(story.querySelectorAll('[data-lv-color-copy]'));
      const triggers = Array.from(story.querySelectorAll('[data-lv-color-trigger]'));
      const current = story.querySelector('[data-lv-color-current]');
      const progressBar = story.querySelector('[data-lv-color-progress]');
      let activeIndex = -1;
      let ticking = false;
      let stableWidth = window.innerWidth;
      const setStableViewport = () => {
        const h = Math.round(window.innerHeight || document.documentElement.clientHeight);
        track.style.setProperty('--lv-color-vh', h + 'px');
      };
      setStableViewport();
      story.querySelectorAll('video').forEach(hardMute);

      const setActive = (index, inView, headerActive) => {
        if (index !== activeIndex) {
          activeIndex = index;
          scenes.forEach((scene, sceneIndex) => {
            scene.classList.toggle('is-active', sceneIndex === index);
          });
          copies.forEach((copy, copyIndex) => {
            copy.classList.toggle('is-active', copyIndex === index);
          });
          triggers.forEach((trigger, triggerIndex) => {
            const isActive = triggerIndex === index;
            trigger.classList.toggle('is-active', isActive);
            if (isActive) {
              trigger.setAttribute('aria-current', 'true');
            } else {
              trigger.removeAttribute('aria-current');
            }
          });
          if (current) current.textContent = String(index + 1).padStart(2, '0');
        }

        const tone = scenes[index]?.dataset.lvHeaderTone || 'light';
        track.dataset.lvTone = tone;
        track.classList.toggle('is-final', index === scenes.length - 1);
        story.classList.toggle('is-header-active', headerActive);
        document.body.classList.toggle('lv-color-story-active', headerActive);
        if (headerActive) {
          document.body.dataset.lvColorHeader = tone;
        } else if (!document.querySelector('[data-lv-color-story].is-header-active')) {
          delete document.body.dataset.lvColorHeader;
        }

        scenes.forEach((scene, sceneIndex) => {
          scene.querySelectorAll('video').forEach((video) => {
            hardMute(video);
            const isVisibleVideo = window.getComputedStyle(video).display !== 'none';
            if (sceneIndex === index && inView && isVisibleVideo && !reducedMotion.matches) {
              const playPromise = video.play();
              if (playPromise) playPromise.catch(() => {});
            } else {
              video.pause();
            }
          });
        });
      };

      const update = () => {
        ticking = false;
        const rect = track.getBoundingClientRect();
        const viewportHeight = parseFloat(getComputedStyle(track).getPropertyValue('--lv-color-vh')) || window.innerHeight || document.documentElement.clientHeight;
        const scrollable = Math.max(rect.height - viewportHeight, 1);
        const progress = Math.min(1, Math.max(0, -rect.top / scrollable));
        const focusLine = viewportHeight * 0.5;
        let index = 0;
        scenes.forEach((scene, sceneIndex) => {
          const sceneRect = scene.getBoundingClientRect();
          if (sceneRect.top <= focusLine) index = sceneIndex;
        });
        index = Math.min(scenes.length - 1, Math.max(0, index));

        const inView = rect.bottom > 0 && rect.top < viewportHeight;
        const headerActive = rect.top <= 1 && rect.bottom > viewportHeight * 0.2;
        setActive(index, inView, headerActive);
        if (progressBar) progressBar.style.setProperty('--lv-color-progress', progress.toFixed(4));
      };

      const requestUpdate = () => {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(update);
      };

      triggers.forEach((trigger, index) => {
        trigger.addEventListener('click', () => {
          const target = scenes[index];
          if (!target) return;
          window.scrollTo({
            top: window.scrollY + target.getBoundingClientRect().top,
            behavior: reducedMotion.matches ? 'auto' : 'smooth'
          });
        });
      });

      const onResize = () => {
        const nextWidth = window.innerWidth;
        if (window.innerWidth > 749 || Math.abs(nextWidth - stableWidth) > 40) {
          stableWidth = nextWidth;
          setStableViewport();
        }
        requestUpdate();
      };
      window.addEventListener('scroll', requestUpdate, { passive: true });
      window.addEventListener('resize', onResize);
      if (reducedMotion.addEventListener) reducedMotion.addEventListener('change', requestUpdate);
      story.lvColorCleanup = () => {
        window.removeEventListener('scroll', requestUpdate);
        window.removeEventListener('resize', onResize);
        if (reducedMotion.removeEventListener) reducedMotion.removeEventListener('change', requestUpdate);
      };
      update();
    });
  };

  initColorStories();
  document.addEventListener('shopify:section:load', (event) => initColorStories(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    const story = event.target.matches('[data-lv-color-story]')
      ? event.target
      : event.target.querySelector('[data-lv-color-story]');
    if (story?.lvColorCleanup) story.lvColorCleanup();
    document.body.classList.remove('lv-color-story-active');
    delete document.body.dataset.lvColorHeader;
  });
})();

(() => {
  const configurations = [{"key":"TOVEN","kind":"canapes","shapes":"modulable canape-lit","handle":"toven-canape-modulable-orange-brule","title":"Composer librement l’espace.","label":"TOVEN · MODULABLE · CANAPÉ LIT","tag":"lomvor:gamme:toven","type":"lomvor:type:canape","prefix":"toven-canape-modulable-"},{"key":"TOVEN_ANGLE","kind":"canapes","shapes":"angle modulable canape-lit","handle":"toven-canape-angle-250-280-vert-sauge","title":"250 ou 280 cm, à composer.","label":"TOVEN · ANGLE MODULABLE","tag":"lomvor:gamme:toven","type":"lomvor:type:canape","prefix":"toven-canape-angle-250-280-"},{"key":"TOVEN_XL2","kind":"canapes","shapes":"angle modulable canape-lit","handle":"toven-canape-angle-300-2-angles-beige","title":"Un grand format modulable.","label":"TOVEN · ANGLE MODULABLE XL","tag":"lomvor:gamme:toven","type":"lomvor:type:canape","prefix":"toven-canape-angle-300-2-angles-"},{"key":"TOVEN_XL3","kind":"canapes","shapes":"angle modulable canape-lit","handle":"toven-canape-angle-300-3-angles-chocolat","title":"Une composition généreuse.","label":"TOVEN · ANGLE MODULABLE XL","tag":"lomvor:gamme:toven","type":"lomvor:type:canape","prefix":"toven-canape-angle-300-3-angles-"},{"key":"KELRAN","kind":"canapes","shapes":"angle","handle":"kelran-canape-d-angle-beige","title":"Dessiner la pièce naturellement.","label":"KELRAN · CANAPÉ D’ANGLE","tag":"lomvor:gamme:kelran","type":"lomvor:type:canape"},{"key":"LUREN","kind":"canapes","shapes":"arrondi 2-places","handle":"luren-canape-arrondi-gris","title":"Des courbes qui adoucissent le salon.","label":"LUREN · FORMES ORGANIQUES","tag":"lomvor:gamme:luren","type":"lomvor:type:canape"},{"key":"VENN","kind":"canapes","shapes":"2-places droit","handle":"venn-canape-2-places-bleu","title":"Compact, net, facile à placer.","label":"VENN · 2 PLACES","tag":"lomvor:gamme:venn","type":"lomvor:type:canape"},{"key":"RIVE","kind":"canapes","shapes":"droit","handle":"rive-canape-vert-sauge","title":"Une ligne simple, une présence douce.","label":"RIVE · CANAPÉ DROIT","tag":"lomvor:gamme:rive","type":"lomvor:type:canape"},{"key":"OVRAN_SOFA","kind":"canapes","shapes":"bubble 2-places","handle":"ovran-canape-bubble-jaune","title":"Le volume comme signature.","label":"OVRAN · CANAPÉ BUBBLE","tag":"lomvor:gamme:ovran","type":"lomvor:type:canape"},{"key":"KOVA","kind":"canapes","shapes":"modulable canape-lit","handle":"kova-canape-convertible-modulable-chocolat","title":"Du canapé au couchage, sans changer de langage.","label":"KOVA · CONVERTIBLE · CANAPÉ LIT","tag":"lomvor:gamme:kova","type":"lomvor:type:canape"},{"key":"SALVEN","kind":"canapes","shapes":"angle 2-places","handle":"salven-canape-taupe-beige","title":"Deux configurations, une même ligne.","label":"SALVEN · 2 PLACES OU ANGLE","tag":"lomvor:gamme:salven","type":"lomvor:type:canape"},{"key":"OVRAN_CHAIR","kind":"fauteuils","shapes":"bubble enveloppant","handle":"ovran-fauteuil-bubble-ocre","title":"Une assise sculpturale et généreuse.","label":"OVRAN · FAUTEUIL BUBBLE","tag":"lomvor:gamme:ovran","type":"lomvor:type:fauteuil"},{"key":"SORI","kind":"fauteuils","shapes":"enveloppant","handle":"sori-fauteuil-1-place-orange-brule","title":"Une silhouette basse et enveloppante.","label":"SORI · FAUTEUIL 1 PLACE","tag":"lomvor:gamme:sori","type":"lomvor:type:fauteuil"},{"key":"NERIN","kind":"fauteuils","shapes":"compact","handle":"nerin-fauteuil-beige","title":"Petit format, vraie présence.","label":"NERIN · FAUTEUIL COMPACT","tag":"lomvor:gamme:nerin","type":"lomvor:type:fauteuil"},{"key":"MIO","kind":"fauteuils","shapes":"compact enveloppant","handle":"mio-fauteuil-1-place-bleu","title":"Une assise compacte aux lignes souples.","label":"MIO · FAUTEUIL 1 PLACE","tag":"lomvor:gamme:mio","type":"lomvor:type:fauteuil"},{"key":"SOVEN","kind":"rocking","shapes":"haut-dossier","handle":"soven-rocking-chair-haut-dossier-vert-fonce","title":"Le confort dans une silhouette verticale.","label":"SOVEN · HAUT DOSSIER","tag":"lomvor:gamme:soven","type":"lomvor:type:fauteuil"},{"key":"KALEN","kind":"rocking","shapes":"compact","handle":"kalen-rocking-chair-compact-creme","title":"Un rocking chair qui prend peu de place.","label":"KALEN · COMPACT","tag":"lomvor:gamme:kalen","type":"lomvor:type:fauteuil"},{"key":"VELTA","kind":"rocking","shapes":"capitonne","handle":"velta-rocking-chair-capitonne-en-velours-marron","title":"Une lecture plus habillée du mouvement.","label":"VELTA · CAPITONNÉ","tag":"lomvor:gamme:velta","type":"lomvor:type:fauteuil"},{"key":"ORSEN","kind":"rocking","shapes":"rembourre","handle":"orsen-rocking-chair-rembourre-gris-clair","title":"Un volume doux, pensé pour durer.","label":"ORSEN · REMBOURRÉ","tag":"lomvor:gamme:orsen","type":"lomvor:type:fauteuil"},{"key":"NEST","kind":"poufs","shapes":"pouf","handle":"nest-ottoman-terracotta","title":"Une place en plus, partout.","label":"NEST · POUF","tag":"lomvor:gamme:nest","type":"lomvor:type:pouf"},{"key":"SORI_POUF","kind":"poufs","shapes":"pouf bubble","handle":"sori-pouf-repose-pieds-bleu","title":"Tout en rondeur.","label":"SORI · POUF BUBBLE","tag":"lomvor:gamme:sori","type":"lomvor:type:pouf"},{"key":"OVRAN_POUF","kind":"poufs","shapes":"pouf bubble","handle":"ovran-ottoman-bubble-vert-olive","title":"Le confort, jusqu’au bout des pieds.","label":"OVRAN · POUF BUBBLE","tag":"lomvor:gamme:ovran","type":"lomvor:type:pouf"},{"key":"MINI-MODULAIRE","kind":"mini","shapes":"canape-enfant modulable","handle":"lomvor-mini-canape-modulable-enfant-beige","title":"Leur salon, à réinventer.","label":"LOMVOR MINI · MODULABLE","tag":"lomvor:gamme:mini-modulaire","type":"lomvor:type:canape-enfant"},{"key":"MINI-2P","kind":"mini","shapes":"canape-enfant 2-places","handle":"lomvor-mini-canape-enfant-2-places-terracotta","title":"Une place pour chacun.","label":"LOMVOR MINI · 2 PLACES","tag":"lomvor:gamme:mini-2-places","type":"lomvor:type:canape-enfant"},{"key":"MINI-3P","kind":"mini","shapes":"canape-enfant 3-places","handle":"lomvor-mini-canape-enfant-3-places-repose-pieds-vert-sauge","title":"Voir les choses en grand.","label":"LOMVOR MINI · 3 PLACES","tag":"lomvor:gamme:mini-3-places-repose-pieds","type":"lomvor:type:canape-enfant"},{"key":"MINI-FAUTEUIL","kind":"mini","shapes":"fauteuil-enfant 1-place","handle":"lomvor-mini-fauteuil-enfant-bleu","title":"Son coin à lui.","label":"LOMVOR MINI · FAUTEUIL","tag":"lomvor:gamme:mini-fauteuil","type":"lomvor:type:fauteuil-enfant"}];
  const palette = {'beige':'#D8CCBE','blanc-ecru':'#F1ECE3','vert-sauge':'#66725A','vert-olive':'#69713F','vert-fonce':'#254C39','chocolat':'#5B4335','marron':'#5B4335','bleu':'#4B647F','bleu-canard':'#247C87','bleu-profond':'#233E77','turquoise':'#268A91','gris':'#92908A','gris-clair':'#BBB7B0','gris-fonce':'#5C5C59','terracotta':'#A95F48','orange-brule':'#B86845','jaune':'#C29B3D','ocre':'#AE8635','noir':'#242421','taupe-greige':'#AAA093','taupe':'#AAA093','rose':'#BC8390','rose-poudre':'#C89F9F','rouge':'#AA4841','creme':'#E7E1D8'};
  const colorNames = {'blanc-ecru':'Blanc écru','vert-sauge':'Vert sauge','vert-olive':'Vert olive','vert-fonce':'Vert foncé','bleu-canard':'Bleu canard','bleu-profond':'Bleu profond','gris-clair':'Gris clair','gris-fonce':'Gris foncé','orange-brule':'Orange brûlé','taupe-greige':'Taupe greige','rose-poudre':'Rose poudré','creme':'Crème'};
  const tagValue = (product, prefix) => (product.tags.find(tag => tag.startsWith(prefix)) || '').slice(prefix.length);
  const initRanges = (root = document) => {
    root.querySelectorAll('[data-lv-range-products]').forEach(source => {
      if (source.dataset.ready) return;
      const section = source.closest('.shopify-section') || source.parentElement;
      const products = JSON.parse(source.textContent);
      const labels = JSON.parse(section.querySelector('[data-lv-range-labels]').textContent);
      const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', {style:'currency',currency:window.Shopify?.currency?.active || 'EUR',maximumFractionDigits: cents % 100 ? 2 : 0}).format(cents / 100);
      const families = new Map(configurations.map(config => [config.key, products.filter(p => p.tags.includes(config.tag) && p.tags.includes(config.type) && (!config.prefix || p.handle.startsWith(config.prefix)))]));
      const cards = Array.from(section.querySelectorAll('[data-range-card]'));
      source.dataset.ready = 'true';
      const colorName = p => {
        const key = tagValue(p, 'lomvor:couleur-exacte:');
        return colorNames[key] || key.replaceAll('-', ' ').replace(/^./, letter => letter.toUpperCase());
      };
      const openOptions = (product,family) => customElements.whenDefined('lomvor-quick-options').then(()=>section.querySelector('lomvor-quick-options').open(product,family,palette));
      const selectProduct = (card, product) => {
        if (!product) return;
        card.rangeProduct = product;
        const image = card.querySelector('.lv-discovery-card__media img');
        if (card.dataset.activeHandle !== product.handle && image) {
          image.removeAttribute('srcset'); image.removeAttribute('sizes'); image.src = product.image; image.alt = product.title;
        }
        card.dataset.activeHandle = product.handle;
        card.querySelectorAll('[data-card-link]').forEach(link => {link.href = product.url;});
        card.querySelector('[data-card-color-label]').textContent = ' · ' + colorName(product);
        const classic = card.dataset.family === 'TOVEN_XL3' ? products.find(p => p.handle === product.handle.replace('-300-3-angles-', '-300-2-angles-')) : null;
        const startingPrice = classic && classic.price > 0 ? Math.min(classic.price, product.price) : product.price;
        card.querySelector('[data-range-price]').textContent = product.price > 0 ? (product.priceVaries || classic ? labels.from + ' ' : '') + money(startingPrice) : labels.pending;
        const pricedProduct = classic && classic.price > 0 && classic.price < product.price ? classic : product;
        const pricedVariant = pricedProduct.variants.find(v => v.price === startingPrice);
        const comparePrice = Number(pricedVariant?.compareAtPrice || 0);
        const compareElement = card.querySelector('[data-range-compare]');
        if (compareElement) {
          compareElement.hidden = !(comparePrice > startingPrice && startingPrice > 0);
          compareElement.textContent = compareElement.hidden ? '' : money(comparePrice);
        }
        card.querySelectorAll('[data-color-handle]').forEach(swatch => {const active=swatch.dataset.colorHandle===product.handle;swatch.classList.toggle('is-active',active);swatch.setAttribute('aria-pressed',String(active));});
        const form = card.querySelector('[data-range-form]');
        const options = card.querySelector('[data-range-options]');
        const fallback = card.querySelector('[data-range-fallback]');
        const purchasable = product.variants.filter(v => v.available && v.price > 0);
        form.hidden = true; options.hidden = true; fallback.hidden = true;
        form.elements.id.value = '';
        if (product.price <= 0 || !purchasable.length) {
          options.hidden = false; options.disabled = true; options.textContent = product.price <= 0 ? labels.pending : labels.unavailable;
        } else if (product.variants.length === 1 && !product.handle.startsWith('kelran-canape-d-angle-')) {
          form.hidden = false; form.elements.id.value = purchasable[0].id;
        } else {
          options.hidden = false; options.disabled = false; options.textContent = labels.choose;
        }
      };
      cards.forEach(card => {
        const family = families.get(card.dataset.family) || [];
        if (!family.length) {card.hidden=true;return;}
        const holder = card.querySelector('[data-card-swatches]');
        holder.replaceChildren();
        family.forEach(product => {
          const key = tagValue(product, 'lomvor:couleur-exacte:');
          const button = document.createElement('button');
          button.type='button'; button.dataset.colorHandle=product.handle;
          button.style.setProperty('--swatch',palette[key] || '#A89C8C');
          button.title=colorName(product);button.setAttribute('aria-label',colorName(product));button.setAttribute('aria-pressed','false');
          button.addEventListener('click',()=>selectProduct(card,product));
          holder.append(button);
        });
        const count=card.querySelector('[data-card-count]');count.hidden=false;count.textContent=family.length+' '+labels.colors;
        card.querySelector('[data-range-options]').addEventListener('click',()=>openOptions(card.rangeProduct,family));
        card.querySelector('[data-range-form]').addEventListener('submit',event=>{const product=card.rangeProduct;const id=card.querySelector('[name="id"]').value;if(!product.variants.some(v=>String(v.id)===id && v.available && v.price>0)){event.preventDefault();return;}card.querySelector('[data-range-add]').disabled=true;});
        selectProduct(card, family.find(p=>p.handle===card.dataset.defaultHandle) || family[0]);
      });
      section.querySelectorAll('[data-lv-discovery]').forEach(discovery => {
        const modeButtons=Array.from(discovery.querySelectorAll('[data-discovery-mode]'));
        const filterGroups=Array.from(discovery.querySelectorAll('[data-discovery-filters]'));
        const explorerCards=Array.from(discovery.querySelectorAll('[data-discovery-card]'));
        const rail=discovery.querySelector('[data-discovery-rail]');
        let mode='canapes',filter='all';
        const modeLabels={canapes:'Canapés',fauteuils:'Fauteuils',rocking:'Rocking chairs',poufs:'Poufs',colors:'Couleurs',mini:'LOMVOR Mini'};
        const activeFilter=()=>discovery.querySelector('[data-discovery-filters="'+mode+'"] .is-active');
        const discoveryOrders={
          all:["TOVEN_XL3","KELRAN","LUREN","KOVA","TOVEN","VENN","TOVEN_ANGLE","RIVE","OVRAN_SOFA","TOVEN_XL2","SALVEN"],
          modulable:['TOVEN','KOVA','TOVEN_ANGLE','TOVEN_XL3','TOVEN_XL2'],
          'canape-lit':['KOVA','TOVEN','TOVEN_XL3','TOVEN_ANGLE','TOVEN_XL2'],
          angle:['TOVEN_ANGLE','KELRAN','TOVEN_XL2','TOVEN_XL3','SALVEN']
        };
        const apply=()=>{
          if(mode==='canapes'){
            const order=discoveryOrders[filter]||discoveryOrders.all;
            const ranked=[...explorerCards].sort((a,b)=>{
              const ai=order.indexOf(a.dataset.family),bi=order.indexOf(b.dataset.family);
              return (ai<0?999:ai)-(bi<0?999:bi);
            });
            const more=discovery.querySelector('[data-discovery-more]');
            ranked.forEach(card=>rail.insertBefore(card,more));
          }else{
            explorerCards.forEach(card=>rail.insertBefore(card,discovery.querySelector('[data-discovery-more]')));
          }
          let visible=0;
          explorerCards.forEach(card=>{
            const family=families.get(card.dataset.family)||[];
            const colorProducts=family.filter(p=>{const color=tagValue(p,'lomvor:couleur-seo:');return filter==='all'||color===filter||(filter==='blanc-ecru'&&color==='blanc');});
            const show=family.length>0 && (mode==='colors' ? colorProducts.length>0 : card.dataset.kind===mode && (filter==='all'||card.dataset.shapes.split(' ').includes(filter)));
            card.hidden=!show;
            if(show){visible++;if(mode==='colors' && filter!=='all')selectProduct(card,colorProducts[0]);}
          });
          discovery.querySelector('[data-discovery-count]').textContent=visible+' gamme'+(visible>1?'s':'');
          const button=activeFilter(),modeButton=modeButtons.find(b=>b.dataset.discoveryMode===mode);
          discovery.querySelector('[data-discovery-context]').textContent=modeLabels[mode]+' · '+(filter==='all'?(mode==='colors'?'Toutes les teintes':'Toutes les gammes'):button.textContent.trim());
          discovery.querySelector('[data-discovery-more]').href=button?.dataset.target||modeButton.dataset.defaultTarget;
          discovery.querySelector('[data-discovery-more-label]').textContent=button?.dataset.label||modeButton.dataset.defaultLabel;
          rail.scrollTo({left:0,behavior:'instant'});
        };
        modeButtons.forEach(button=>button.addEventListener('click',()=>{
          mode=button.dataset.discoveryMode;filter='all';
          modeButtons.forEach(b=>{b.classList.toggle('is-active',b===button);b.setAttribute('aria-selected',String(b===button));});
          filterGroups.forEach(group=>{group.classList.toggle('is-active',group.dataset.discoveryFilters===mode);group.querySelectorAll('[data-discovery-filter]').forEach((b,i)=>b.classList.toggle('is-active',i===0));});
          explorerCards.forEach(card=>{const family=families.get(card.dataset.family)||[];selectProduct(card,family.find(p=>p.handle===card.dataset.defaultHandle)||family[0]);});
          apply();
        }));
        filterGroups.forEach(group=>group.querySelectorAll('[data-discovery-filter]').forEach(button=>button.addEventListener('click',()=>{
          group.querySelectorAll('[data-discovery-filter]').forEach(b=>b.classList.toggle('is-active',b===button));filter=button.dataset.discoveryFilter;apply();
        })));
        discovery.querySelector('[data-discovery-prev]').addEventListener('click',()=>rail.scrollBy({left:-rail.clientWidth*.85,behavior:'smooth'}));
        discovery.querySelector('[data-discovery-next]').addEventListener('click',()=>rail.scrollBy({left:rail.clientWidth*.85,behavior:'smooth'}));
        apply();
      });
    });
  };
  initRanges();
  document.addEventListener('shopify:section:load',event=>initRanges(event.target));
})();


  document.querySelectorAll('.lv-rocking-shop-card__swatches [data-rocking-swatch]').forEach((swatch) => {
    swatch.addEventListener('click', (event) => {
      event.preventDefault();
      const card = swatch.closest('.lv-rocking-shop-card');
      if (!card) return;
      const image = card.querySelector('.lv-rocking-shop-card__media img');
      const mediaLink = card.querySelector('.lv-rocking-shop-card__media');
      const titleLink = card.querySelector('.lv-rocking-shop-card__title');
      const discoverLink = card.querySelector('.lv-rocking-shop-card__discover');
      const eyebrow = card.querySelector('.lv-rocking-shop-card__eyebrow');
      if (image && swatch.dataset.swatchImage) {
        image.removeAttribute('srcset');
        image.removeAttribute('sizes');
        image.src = swatch.dataset.swatchImage;
        image.alt = swatch.dataset.swatchLabel + ' LOMVOR';
      }
      [mediaLink,titleLink,discoverLink].forEach((link) => { if (link) link.href = swatch.href; });
      if (eyebrow) eyebrow.textContent = swatch.dataset.swatchLabel;
      card.querySelectorAll('[data-rocking-swatch]').forEach((item) => item.classList.toggle('is-active', item === swatch));
    });
  });


(() => {
  const init = (root = document) => root.querySelectorAll('[data-home-slider]').forEach(rail => {
    if (rail.dataset.sliderReady) return;
    rail.dataset.sliderReady = 'true';
    const nav = document.createElement('div');
    nav.className = 'lv-home-slider-nav';
    const previous = document.createElement('button');
    previous.type = 'button'; previous.setAttribute('aria-label', 'Produits précédents');
    previous.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m14 5-7 7 7 7"/></svg>';
    const bar = document.createElement('div'); bar.className = 'lv-home-slider-bar'; bar.setAttribute('aria-hidden', 'true');
    const thumb = document.createElement('i'); bar.append(thumb);
    const next = document.createElement('button');
    next.type = 'button'; next.setAttribute('aria-label', 'Produits suivants');
    next.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m10 5 7 7-7 7"/></svg>';
    nav.append(previous, bar, next); rail.after(nav);
    const update = () => {
      const max = Math.max(0, rail.scrollWidth - rail.clientWidth);
      const width = Math.max(12, Math.min(100, rail.clientWidth / Math.max(1, rail.scrollWidth) * 100));
      const position = max ? Math.max(0, Math.min(1, rail.scrollLeft / max)) : 0;
      thumb.style.width = width + '%'; thumb.style.left = position * (100 - width) + '%';
      nav.hidden = max < 3; previous.disabled = rail.scrollLeft < 3; next.disabled = rail.scrollLeft >= max - 3;
    };
    const move = direction => {
      const card = Array.from(rail.children).find(item => !item.hidden);
      const gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
      const step = card ? card.getBoundingClientRect().width + gap : rail.clientWidth;
      rail.scrollBy({left: direction * step, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    };
    previous.addEventListener('click', () => move(-1)); next.addEventListener('click', () => move(1));
    rail.addEventListener('keydown', event => {if(event.target === rail && ['ArrowLeft','ArrowRight'].includes(event.key)){event.preventDefault();move(event.key === 'ArrowRight' ? 1 : -1);}});
    rail.addEventListener('scroll', update, {passive:true});
    const refresh = update;
    const resize = new ResizeObserver(refresh); resize.observe(rail);
    const mutation = new MutationObserver(() => {requestAnimationFrame(() => {rail.scrollTo({left:0,behavior:'instant'});update();});}); mutation.observe(rail, {subtree:true,attributes:true,attributeFilter:['hidden']});
    refresh();
    rail.closest('.shopify-section')?.addEventListener('shopify:section:unload', () => {resize.disconnect();mutation.disconnect();}, {once:true});
  });
  init(); document.addEventListener('shopify:section:load', event => init(event.target));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lomvor-product-after"]) return;
  try {
    
(() => {
  const init = (scope = document) => {
    scope.querySelectorAll('[data-lv-tabs]').forEach((root) => {
      if (root.dataset.lvReady === 'true') return;
      root.dataset.lvReady = 'true';
      const tabs = [...root.querySelectorAll('[data-lv-tab]')];
      const panels = [...root.querySelectorAll('[data-lv-panel]')];
      const scenes = [...root.querySelectorAll('[data-lv-scene]')];
      tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          const key = tab.dataset.lvTab;
          tabs.forEach((item) => {
            const active = item === tab;
            item.classList.toggle('is-active', active);
            item.setAttribute('aria-selected', active ? 'true' : 'false');
          });
          panels.forEach((panel) => {
            const active = panel.dataset.lvPanel === key;
            panel.hidden = !active;
            panel.classList.toggle('is-active', active);
          });
          scenes.forEach((scene) => {
            const active = scene.dataset.lvScene === key;
            scene.hidden = !active;
            scene.classList.toggle('is-active', active);
          });
        });
      });
    });

    const normalizeColor = (value = '') =>
      value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();

    const colorHex = (value) => {
      const name = normalizeColor(value);
      if (name.includes('blanc') || name.includes('creme')) return '#eee8de';
      if (name.includes('beige')) return '#d8ccbe';
      if (name.includes('sauge')) return '#74765d';
      if (name.includes('vert fonce')) return '#465340';
      if (name.includes('vert')) return '#66725a';
      if (name.includes('chocolat') || name.includes('marron')) return '#5b4335';
      if (name.includes('rouge')) return '#a94f43';
      if (name.includes('terracotta')) return '#a95f48';
      if (name.includes('orange')) return '#b7673e';
      if (name.includes('taupe')) return '#9b8f82';
      if (name.includes('gris fonce')) return '#66645f';
      if (name.includes('gris')) return '#8b8982';
      if (name.includes('bleu profond')) return '#394b63';
      if (name.includes('bleu canard')) return '#37666b';
      if (name.includes('bleu')) return '#506a85';
      if (name.includes('ocre')) return '#b77b3e';
      if (name.includes('jaune') || name.includes('moutarde')) return '#c7a245';
      if (name.includes('noir')) return '#292722';
      return '#d8ccbe';
    };

    scope.querySelectorAll('[data-lv-ovran-format]').forEach((root) => {
      if (root.dataset.lvOvranReady === 'true') return;
      root.dataset.lvOvranReady = 'true';

      const widthLabel = root.querySelector('[data-lv-ovran-width]');
      const heightLabel = root.querySelector('[data-lv-ovran-height]');
      const heading = root.querySelector('[data-lv-ovran-heading]');
      const measures = root.querySelector('[data-lv-ovran-measures]');
      const copy = root.querySelector('[data-lv-ovran-copy]');
      const cards = [...root.querySelectorAll('[data-lv-ovran-card]')];
      const picker = document.querySelector('variant-picker');

      const configs = {
        '2': {
          heading: '2 places',
          width: '190 cm',
          height: 'H. 77 cm',
          measures: '190 × 113 × 77 cm',
          copy: 'Le format le plus concentré : 190 cm de largeur pour garder toute la présence Bubble dans une emprise plus contenue.'
        },
        '3': {
          heading: '3 places',
          width: '240 cm',
          height: 'H. 80 cm',
          measures: '240 × 113 × 80 cm',
          copy: 'La version la plus ample : 240 cm de largeur pour étirer les volumes Bubble et faire d’OVRAN la pièce maîtresse du salon.'
        }
      };

      const normalize = (value) => String(value || '').toLowerCase().includes('3 places') ? '3' : '2';

      const update = (value) => {
        const key = normalize(value);
        const config = configs[key];
        if (!config) return;

        if (widthLabel) widthLabel.textContent = 'L. ' + config.width;
        if (heightLabel) heightLabel.textContent = config.height;
        if (heading) heading.textContent = config.heading;
        if (measures) measures.textContent = config.measures;
        if (copy) copy.textContent = config.copy;

        cards.forEach((card) => {
          const active = card.dataset.lvOvranCard === key;
          card.classList.toggle('is-active', active);
          card.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
      };

      const selected = picker?.querySelector('input[name="option-Format"]:checked, select[name="option-Format"]');
      update(selected?.value || '2 places');

      picker?.addEventListener('change', (event) => {
        const target = event.target;
        if (!(target instanceof HTMLInputElement || target instanceof HTMLSelectElement)) return;
        if (target.name !== 'option-Format') return;
        update(target.value);
      });

      cards.forEach((card) => {
        card.addEventListener('click', () => {
          const wanted = card.dataset.lvOvranCard === '3' ? '3 places' : '2 places';
          const input = picker?.querySelector('input[name="option-Format"][value="' + wanted + '"]');
          if (input instanceof HTMLInputElement) {
            input.click();
            return;
          }
          const select = picker?.querySelector('select[name="option-Format"]');
          if (select instanceof HTMLSelectElement) {
            select.value = wanted;
            select.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      });
    });

    scope.querySelectorAll('[data-lv-salven-config]').forEach((root) => {
      if (root.dataset.lvSalvenReady === 'true') return;
      root.dataset.lvSalvenReady = 'true';

      const widthLabel = root.querySelector('[data-lv-salven-width]');
      const heading = root.querySelector('[data-lv-salven-heading]');
      const measures = root.querySelector('[data-lv-salven-measures]');
      const copy = root.querySelector('[data-lv-salven-copy]');
      const extraWrap = root.querySelector('[data-lv-salven-extra-wrap]');
      const visuals = [...root.querySelectorAll('[data-lv-salven-visual]')];
      const cards = [...root.querySelectorAll('[data-lv-salven-card]')];
      const picker = document.querySelector('variant-picker');

      const configs = {
        '2': {
          heading: '2 places',
          width: '182 cm',
          measures: '182 × 92 × 71 cm',
          copy: 'Le format le plus contenu de SALVEN : 182 cm de largeur pour structurer le salon sans occuper inutilement l’espace.'
        },
        '3': {
          heading: '3 places + repose-pieds',
          width: '272 cm',
          measures: '272 × 92 × 71 cm',
          copy: 'La configuration la plus généreuse : 272 cm de largeur, complétés par un repose-pieds de 90 × 92 × 35 cm pour étendre naturellement la zone d’assise.'
        }
      };

      const normalize = (value) => String(value || '').toLowerCase().includes('3 places') ? '3' : '2';

      const update = (value) => {
        const key = normalize(value);
        const config = configs[key];
        if (!config) return;

        if (widthLabel) widthLabel.textContent = 'L. ' + config.width;
        if (heading) heading.textContent = config.heading;
        if (measures) measures.textContent = config.measures;
        if (copy) copy.textContent = config.copy;
        if (extraWrap) extraWrap.hidden = key !== '3';

        visuals.forEach((visual) => {
          visual.hidden = visual.dataset.lvSalvenVisual !== key;
        });

        cards.forEach((card) => {
          const active = card.dataset.lvSalvenCard === key;
          card.classList.toggle('is-active', active);
          card.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
      };

      const selected = picker?.querySelector('input[name="option-Configuration"]:checked, select[name="option-Configuration"]');
      update(selected?.value || '2 places');

      picker?.addEventListener('change', (event) => {
        const target = event.target;
        if (!(target instanceof HTMLInputElement || target instanceof HTMLSelectElement)) return;
        if (target.name !== 'option-Configuration') return;
        update(target.value);
      });

      cards.forEach((card) => {
        card.addEventListener('click', () => {
          const wanted = card.dataset.lvSalvenCard === '3' ? '3 places + repose-pieds' : '2 places';
          const input = picker?.querySelector('input[name="option-Configuration"][value="' + wanted + '"]');
          if (input instanceof HTMLInputElement) {
            input.click();
            return;
          }
          const select = picker?.querySelector('select[name="option-Configuration"]');
          if (select instanceof HTMLSelectElement) {
            select.value = wanted;
            select.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      });
    });

    scope.querySelectorAll('[data-lv-luren-dimensions]').forEach((root) => {
      if (root.dataset.lvLurenReady === 'true') return;
      root.dataset.lvLurenReady = 'true';

      const widthLabel = root.querySelector('[data-lv-luren-width]');
      const heading = root.querySelector('[data-lv-luren-heading]');
      const measures = root.querySelector('[data-lv-luren-measures]');
      const copy = root.querySelector('[data-lv-luren-copy]');
      const cards = [...root.querySelectorAll('[data-lv-luren-size]')];
      const picker = document.querySelector('variant-picker');

      const sizes = {
        '240': {
          measures: '240 × 102 × 60 cm',
          copy: 'Le format le plus contenu : toute la signature arrondie de LUREN avec une présence plus facile à intégrer dans un salon mesuré.'
        },
        '280': {
          measures: '280 × 102 × 60 cm',
          copy: 'L’équilibre de la gamme : davantage d’ampleur visuelle tout en restant simple à intégrer dans la plupart des grandes pièces de vie.'
        },
        '340': {
          measures: '340 × 102 × 60 cm',
          copy: 'La version manifeste : une grande ligne courbe pensée pour les pièces qui peuvent lui laisser de l’air et assumer une vraie pièce maîtresse.'
        }
      };

      const normalize = (value) => String(value || '').match(/240|280|340/)?.[0] || '240';

      const update = (value) => {
        const size = normalize(value);
        const config = sizes[size];
        if (!config) return;

        if (widthLabel) widthLabel.textContent = 'L. ' + size + ' cm';
        if (heading) heading.textContent = size + ' cm';
        if (measures) measures.textContent = config.measures;
        if (copy) copy.textContent = config.copy;

        cards.forEach((card) => {
          const active = card.dataset.lvLurenSize === size;
          card.classList.toggle('is-active', active);
          card.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
      };

      const selected = picker?.querySelector('input[name="option-Longueur"]:checked, select[name="option-Longueur"]');
      update(selected?.value || '240 cm');

      picker?.addEventListener('change', (event) => {
        const target = event.target;
        if (!(target instanceof HTMLInputElement || target instanceof HTMLSelectElement)) return;
        if (target.name !== 'option-Longueur') return;
        update(target.value);
      });

      cards.forEach((card) => {
        card.addEventListener('click', () => {
          const size = card.dataset.lvLurenSize;
          const input = picker?.querySelector('input[name="option-Longueur"][value="' + size + ' cm"]');
          if (input instanceof HTMLInputElement) {
            input.click();
            return;
          }
          const select = picker?.querySelector('select[name="option-Longueur"]');
          if (select instanceof HTMLSelectElement) {
            select.value = size + ' cm';
            select.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      });
    });

    scope.querySelectorAll('[data-lv-nerin-dimensions]').forEach((root) => {
      if (root.dataset.lvNerinReady === 'true') return;
      root.dataset.lvNerinReady = 'true';

      const width = root.querySelector('[data-lv-trust-width]');
      const height = root.querySelector('[data-lv-trust-height]');
      const depth = root.querySelector('[data-lv-trust-depth]');
      const measure = root.querySelector('[data-lv-trust-measure]');
      const copy = root.querySelector('[data-lv-trust-copy]');
      const cards = [...root.querySelectorAll('[data-lv-nerin-size]')];
      const picker = document.querySelector('variant-picker');

      const configs = {
        '85': {
          width: '85 cm',
          height: 'H. 70 cm',
          depth: 'P. 85 cm',
          measure: '85 × 85 × 70 cm',
          copy: 'Le format Petit garde davantage d’air autour du fauteuil et convient lorsque vous voulez une présence plus contenue dans la pièce.'
        },
        '100': {
          width: '100 cm',
          height: 'H. 70 cm',
          depth: 'P. 100 cm',
          measure: '100 × 100 × 70 cm',
          copy: 'Le format Grand gagne en ampleur et en présence tout en conservant la même hauteur de 70 cm.'
        }
      };

      const normalize = (value) => String(value || '').includes('100') ? '100' : '85';

      const update = (value) => {
        const key = normalize(value);
        const config = configs[key];
        if (!config) return;
        if (width) width.textContent = 'L. ' + config.width;
        if (height) height.textContent = config.height;
        if (depth) depth.textContent = config.depth;
        if (measure) measure.textContent = config.measure;
        if (copy) copy.textContent = config.copy;
        cards.forEach((card) => card.classList.toggle('is-active', card.dataset.lvNerinSize === key));
      };

      const selected = picker?.querySelector('input[name="option-Taille"]:checked, select[name="option-Taille"]');
      update(selected?.value || 'Petit — 85 cm');

      picker?.addEventListener('change', (event) => {
        const target = event.target;
        if (!(target instanceof HTMLInputElement || target instanceof HTMLSelectElement)) return;
        if (target.name !== 'option-Taille') return;
        update(target.value);
      });
    });


    scope.querySelectorAll('[data-lv-angle-dimensions]').forEach((root) => {
      if (root.dataset.lvAngleReady === 'true') return;
      root.dataset.lvAngleReady = 'true';
      const picker = document.querySelector('variant-picker');
      const update = (value) => {
        const parts = String(value || '').match(/\d+/g);
        if (!parts || parts.length < 3) return;
        root.querySelector('[data-lv-angle-width]').textContent = 'L. ' + parts[0] + ' cm';
        root.querySelector('[data-lv-angle-depth]').textContent = 'P. ' + parts[1] + ' cm';
      };
      const selected = picker?.querySelector('input[name="option-Taille"]:checked, select[name="option-Taille"]');
      if (selected) update(selected.value);
      picker?.addEventListener('change', (event) => {
        if (event.target.name === 'option-Taille') update(event.target.value);
      });
    });

    scope.querySelectorAll('[data-lv-dimensions]').forEach((root) => {
      if (root.dataset.lvSizeReady === 'true') return;
      root.dataset.lvSizeReady = 'true';

      const widthLabel = root.querySelector('[data-lv-dim-width]');
      const heading = root.querySelector('[data-lv-size-heading]');
      const measures = root.querySelector('[data-lv-size-measures]');
      const bed = root.querySelector('[data-lv-bed-size]');
      const copy = root.querySelector('[data-lv-size-copy]');
      const sizeCards = [...root.querySelectorAll('[data-lv-size-card]')];
      const picker = document.querySelector('variant-picker');

      const sizes = {
        '150': {
          measures: '150 × 100 × 70 cm',
          bed: '150 × 180 cm',
          copy: 'Le format compact pour préserver l’espace, tout en conservant un couchage d’appoint de 150 × 180 cm. Pour davantage d’aisance, passez en 180 ou 200 cm.'
        },
        '180': {
          measures: '180 × 100 × 70 cm',
          bed: '180 × 180 cm',
          copy: 'L’équilibre idéal entre présence dans le salon et surface de couchage : 180 × 180 cm pour recevoir confortablement sans surdimensionner la pièce.'
        },
        '200': {
          measures: '200 × 100 × 70 cm',
          bed: '200 × 180 cm',
          copy: 'La version la plus généreuse : 200 × 180 cm de couchage d’appoint, avec un maximum d’aisance au quotidien.'
        }
      };

      const normalize = (value) => String(value || '').match(/150|180|200/)?.[0] || '150';

      const update = (value) => {
        const size = normalize(value);
        const config = sizes[size];
        if (!config) return;

        if (widthLabel) widthLabel.textContent = 'L. ' + size + ' cm';
        if (heading) heading.textContent = size + ' cm';
        if (measures) measures.textContent = config.measures;
        if (bed) bed.textContent = config.bed;
        if (copy) copy.textContent = config.copy;

        sizeCards.forEach((card) => {
          const active = card.dataset.lvSizeCard === size;
          card.classList.toggle('is-active', active);
          card.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
      };

      const selected = picker?.querySelector('input[name="option-Taille"]:checked, select[name="option-Taille"]');
      update(selected?.value || '150 cm');

      picker?.addEventListener('change', (event) => {
        const target = event.target;
        if (!(target instanceof HTMLInputElement || target instanceof HTMLSelectElement)) return;
        if (target.name !== 'option-Taille') return;
        update(target.value);
      });

      sizeCards.forEach((card) => {
        card.addEventListener('click', () => {
          const size = card.dataset.lvSizeCard;
          const input = picker?.querySelector('input[name="option-Taille"][value="' + size + ' cm"]');
          if (input instanceof HTMLInputElement) {
            input.click();
            return;
          }
          const select = picker?.querySelector('select[name="option-Taille"]');
          if (select instanceof HTMLSelectElement) {
            select.value = size + ' cm';
            select.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      });
    });

    scope.querySelectorAll('[data-lv-compose]').forEach((root) => {
      if (root.dataset.lvReady === 'true') return;
      root.dataset.lvReady = 'true';

      const rail = root.querySelector('[data-lv-compose-rail]');
      const prev = root.querySelector('[data-lv-compose-prev]');
      const next = root.querySelector('[data-lv-compose-next]');
      const composeColorName = root.querySelector('[data-lv-compose-color-name]');
      const composeColorButtons = [...root.querySelectorAll('[data-lv-compose-color]')];
      const cards = [...root.querySelectorAll('[data-lv-compose-card]')];

      const updateCard = (card, swatch) => {
        if (!card || !swatch) return;
        const image = card.querySelector('.lv-compose-card__image');
        const title = card.querySelector('[data-lv-compose-title]');
        const price = card.querySelector('[data-lv-compose-price]');
        const link = card.querySelector('[data-lv-compose-link]');
        const addButton = card.querySelector('[data-lv-compose-add]');
        const addButtonPrice = card.querySelector('[data-lv-compose-button-price]');
        const swatches = [...card.querySelectorAll('[data-lv-compose-swatch]')];

        swatches.forEach((item) => item.classList.toggle('is-active', item === swatch));

        if (image && swatch.dataset.image) {
          image.removeAttribute('srcset');
          image.src = swatch.dataset.image;
          image.alt = swatch.dataset.title || '';
        }
        if (title) title.textContent = swatch.dataset.title || '';
        if (price) price.textContent = swatch.dataset.price || '';
        if (link && swatch.dataset.url) link.href = swatch.dataset.url;
        if (addButton && swatch.dataset.variant) addButton.dataset.variant = swatch.dataset.variant;
        if (addButtonPrice && swatch.dataset.price) addButtonPrice.textContent = '— ' + swatch.dataset.price;
      };

      cards.forEach((card) => {
        const swatches = [...card.querySelectorAll('[data-lv-compose-swatch]')];

        swatches.forEach((swatch) => {
          swatch.style.setProperty('--swatch', colorHex(swatch.dataset.color || ''));
          swatch.addEventListener('click', () => updateCard(card, swatch));
        });

        const addButton = card.querySelector('[data-lv-compose-add]');
        addButton?.addEventListener('click', async () => {
          const variantId = Number(addButton.dataset.variant);
          if (!variantId) return;

          const originalHtml = addButton.innerHTML;
          addButton.disabled = true;
          addButton.textContent = 'Ajout en cours…';

          const sections = ['auto-gifts'];
          const cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer?.dataset.sectionId) sections.push(cartDrawer.dataset.sectionId);

          try {
            const response = await fetch(window.Theme?.routes?.cart_add_url || '/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({
                items: [{ id: variantId, quantity: 1 }],
                sections: sections.join(','),
              }),
            });
            const data = await response.json();
            if (!response.ok || data.status) throw new Error(data.description || 'Ajout impossible');

            const cartIcon = document.querySelector('cart-icon');
            const currentCount = cartIcon?.getCurrentItemCount?.() || 0;
            document.dispatchEvent(
              new CustomEvent('cart:updated', {
                bubbles: true,
                detail: {
                  resource: data,
                  data: {
                    itemCount: currentCount + 1,
                    source: 'lomvor-compose',
                    sections: data.sections,
                  },
                },
              }),
            );

            addButton.classList.add('is-added');
            addButton.innerHTML = 'Ajouté au panier <span aria-hidden="true">✓</span>';
            setTimeout(() => {
              addButton.classList.remove('is-added');
              addButton.innerHTML = originalHtml;
            }, 1600);
          } catch (error) {
            console.error(error);
            addButton.textContent = 'Réessayer';
          } finally {
            addButton.disabled = false;
          }
        });
      });

      const exactColorMatch = (candidate, target) => {
        const c = normalizeColor(candidate);
        const t = normalizeColor(target);

        if (c === t) return true;

        // Neutres réellement interchangeables dans notre assortiment.
        if (t === 'beige' && c === 'creme') return true;
        if (t.includes('blanc') && c === 'creme') return true;

        // SALVEN utilise "Taupe beige" tandis que les pièces associées sont
        // nommées "Taupe greige" : même famille taupe, donc correspondance voulue.
        if (t.includes('taupe') && c.includes('taupe')) return true;

        return false;
      };

      const collectionState = (label) => {
        const name = normalizeColor(label);
        // Tester taupe avant beige : "Taupe beige" doit rester dans la palette taupe.
        if (name.includes('taupe')) return ['meubles-taupe', 'Découvrir tous les meubles taupe'];
        if (name.includes('beige')) return ['meubles-beige', 'Découvrir tous les meubles beige'];
        if (name.includes('blanc')) return ['meubles-blanc-ecru', 'Découvrir tous les meubles blanc écru'];
        if (name.includes('bleu')) return ['meubles-bleu', 'Découvrir tous les meubles bleus'];
        if (name.includes('chocolat') || name.includes('marron')) return ['meubles-marron', 'Découvrir tous les meubles marron'];
        if (name.includes('gris')) return ['meubles-gris', 'Découvrir tous les meubles gris'];
        if (name.includes('rouge')) return ['meubles-rouge', 'Découvrir tous les meubles rouges'];
        if (name.includes('jaune') || name.includes('ocre') || name.includes('moutarde')) return ['meubles-jaune', 'Découvrir tous les meubles jaune et ocre'];
        if (name.includes('noir')) return ['meubles-noir', 'Découvrir tous les meubles noirs'];
        if (name.includes('orange') || name.includes('terracotta')) return ['meubles-terracotta', 'Découvrir tous les meubles terracotta et orange brûlé'];
        if (name.includes('sauge') || name.includes('vert')) return ['meubles-vert', 'Découvrir tous les meubles verts'];
        return ['', ''];
      };

      const selectLocalComposerColor = (label) => {
        const visibleProducts = new Set();
        let matchedCount = 0;

        cards.forEach((card) => {
          const swatches = [...card.querySelectorAll('[data-lv-compose-swatch]')];
          const match = swatches.find((swatch) => exactColorMatch(swatch.dataset.color || '', label));

          if (!match) {
            card.hidden = true;
            return;
          }

          const productKey = match.dataset.url || match.dataset.variant || match.dataset.title || '';
          if (visibleProducts.has(productKey)) {
            card.hidden = true;
            return;
          }

          visibleProducts.add(productKey);
          matchedCount += 1;
          card.hidden = false;
          updateCard(card, match);
        });

        if (matchedCount === 0) {
          const fallbackProducts = new Set();
          cards.forEach((card) => {
            const swatches = [...card.querySelectorAll('[data-lv-compose-swatch]')];
            const fallback = swatches[0];
            if (!fallback) {
              card.hidden = true;
              return;
            }

            const productKey = fallback.dataset.url || fallback.dataset.variant || fallback.dataset.title || '';
            if (!productKey || fallbackProducts.has(productKey) || fallbackProducts.size >= 3) {
              card.hidden = true;
              return;
            }

            fallbackProducts.add(productKey);
            card.hidden = false;
            updateCard(card, fallback);
          });
        }

        composeColorButtons.forEach((button) => {
          button.classList.toggle('is-current', normalizeColor(button.dataset.color || '') === normalizeColor(label));
        });
        if (composeColorName) composeColorName.textContent = label;

        const [handle, copy] = collectionState(label);
        const box = root.querySelector('[data-lv-compose-collection]');
        const link = root.querySelector('[data-lv-compose-collection-link]');
        const copyEl = root.querySelector('[data-lv-compose-collection-copy]');

        if (handle) {
          box?.removeAttribute('hidden');
          if (link) link.href = '/collections/' + handle;
          if (copyEl) copyEl.textContent = copy;
        } else {
          box?.setAttribute('hidden', '');
        }

        rail?.scrollTo({ left: 0, behavior: 'smooth' });
      };

      composeColorButtons.forEach((button) => {
        button.addEventListener('click', () => selectLocalComposerColor(button.dataset.color || ''));
      });

      const scrollRail = (direction) => {
        if (!rail) return;
        const visibleCard = cards.find((card) => !card.hidden);
        const amount = visibleCard ? visibleCard.getBoundingClientRect().width + 15 : rail.clientWidth * .85;
        rail.scrollBy({ left: amount * direction, behavior: 'smooth' });
      };

      prev?.addEventListener('click', () => scrollRail(-1));
      next?.addEventListener('click', () => scrollRail(1));

      const initialComposeColor = composeColorName?.textContent?.trim();
      if (initialComposeColor) selectLocalComposerColor(initialComposeColor);
    });
  };
  init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lomvor-review-banner"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('lv-review-rotation')) {
  customElements.define('lv-review-rotation', class extends HTMLElement {
    connectedCallback() {
      clearInterval(this.timer);
      this.slides = [...this.querySelectorAll('[data-review-slide]')];
      this.index = 0;
      this.slides.forEach((slide, index) => { slide.hidden = index !== 0; });
      this.timer = setInterval(() => {
        if (document.hidden || this.slides.length < 2) return;
        this.index = (this.index + 1) % this.slides.length;
        this.slides.forEach((slide, index) => { slide.hidden = index !== this.index; });
      }, 4500);
    }
    disconnectedCallback() { clearInterval(this.timer); }
  });
}

  } catch(e) { console.error(e); }
})();
})();
